module.exports = __webpack_public_path__ + "img/courier-tforcefreight.0da0ac18.svg";